<template>
    <b-modal title="Arraignment"
             size="lg"
             class="font-weight-bold"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @hidden="onDialogHidden">
        <vue-keypress key-event="keydown" :key-code="83" :modifiers="['altKey']" :preventDefault="true" @success="accusedCountType = 'single'"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="77" :modifiers="['altKey']" :preventDefault="true" @success="accusedCountType = 'multiple'"></vue-keypress>

        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in currentErrors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>


        <b-form-row>
            <b-form-group class="col-md-7">
                <b-form-radio-group name="accusedCountType" 
                                    v-model="accusedCountType"
                                    buttons
                                    button-variant="outline-secondary"
                                    @input="accusedCountTypeChanged">
                    <b-form-radio value="single">Single Accused (Alt+S)</b-form-radio>
                    <b-form-radio value="multiple">Multiple Accused (Alt+M)</b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <b-form-group label="Charge Number"
                          label-for="chargeNumber"
                          label-cols-md="5"
                          class="col-md-5 pr-0 float-right">
                <b-form-input name="chargeNumber"  class="col-md-5" v-model="chargeNumber" type="number" min="1"></b-form-input>
            </b-form-group>
            <b-form-group label="Description of Charge"
                          label-for="descriptionOfCharge"
                          class="col-12">
                <b-form-textarea v-model="descriptionOfCharge"
                                 rows="6"
                                 autofocus>
                </b-form-textarea>
            </b-form-group>
        </b-form-row>
        <b-list-group flush>
            <b-list-group-item class="d-flex justify-content-between align-items-start pl-1 pr-0"
                               v-for="(accused, index) in listOfAccused"
                               :key="index">
                <div class="p-0 m-0 flex-grow-1">
                    {{ accused.nameOfAccused  }}
                </div>
                <b-form-radio-group v-model="accused.pleaStatus"
                                    :options="pleaStatusOptions"
                                    buttons
                                    button-variant="outline-secondary"
                                    size="sm">
                </b-form-radio-group>
                <b-button variant="warning" title="Delete Accused" v-on:click="deleteAccused(accused)" size="sm" class="ml-2" v-if="accusedCountType == 'multiple'">Delete</b-button>
            </b-list-group-item>
        </b-list-group>
        <div class="d-flex align-items-start mt-2" v-if="accusedCountType == 'multiple'">
            <b-form-group class="flex-grow-1">
                <b-form-input name="nameOfAccused"
                              v-model="nameOfAccused"
                              placeholder="Name of Accused">
                </b-form-input>
            </b-form-group>
            <b-button variant="primary" class="ml-2" title="Add Accused to List" v-on:click="addToList">Add to List</b-button>
        </div>
        
        <template v-slot:modal-footer="{ cancel }">
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="success" @click="insert">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import VueKeypress from 'vue-keypress';
    import { v4 as newUuid } from 'uuid';

    import EventsMixin from '../../mixins/EventsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeChargeAndPleaDialog',
        mixins: [EventsMixin],
        components: {
            'vue-keypress': VueKeypress
        },
        model: {
            event: 'change',
            prop: 'active',

        },
        props: {
            configuration: {
                type: Object,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'insert',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['insert', 'edit'].indexOf(value) !== -1);
                }
            },
            currentEditorSection: {
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                currentConfiguration: null,
                configurationDirty: false,
                currentErrors: null,
                showErrors: false,

                accusedCountTypeOptions: [
                    {
                        text: 'Single Accused (Alt+S)',
                        value: 'single'
                    },
                    {
                        text: 'Multiple Accused (Alt+M)',
                        value: 'multiple'
                    }
                ],
                accusedCountType: 'single',
                chargeNumber: 1,
                descriptionOfCharge: null,
                pleaStatusOptions: [
                    {
                        text: 'not guilty',
                        value: 'not-guilty'
                    },
                    {
                        text: 'guilty',
                        value: 'guilty'
                    }
                ],
                listOfAccused: [
                    {
                        nameOfAccused: 'THE ACCUSED',
                        pleaStatus: null
                    } 
                ], 
                nameOfAccused: null,
                
                sectionsInsertedEventData: null
            }
        },
        watch: {
            configuration: function () {
                this.currentConfiguration = this.configuration;
            },
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.currentErrors = null;
                    if (this.mode == 'edit') {
                        try {
                            var base64EncodedMetaData = $(this.currentEditorSection).data('metadata');
                            var metaData = JSON.parse(atob(base64EncodedMetaData));
                            this.chargeNumber = metaData.ChargeNumber;
                            this.descriptionOfCharge = metaData.Description.replaceAll('<br>', '\r\n');
                            this.listOfAccused = [];
                            metaData.Accused.forEach((accused) => {
                                if (accused.Name != null) {
                                    this.accusedCountType = 'multiple';
                                    this.listOfAccused.push({ nameOfAccused: accused.Name, pleaStatus: accused.Guilty ? 'guilty' : 'not-guilty' });
                                } else {
                                    this.accusedCountType = 'single';
                                    this.listOfAccused.push({ nameOfAccused: 'THE ACCUSED', pleaStatus: accused.Guilty ? 'guilty' : 'not-guilty' });
                                }
                            });
                        }
                        catch
                        {
                            console.warn('invalid metadata in section');
                        }
                    } else if (this.currentConfiguration != null) {
                        if (this.currentConfiguration.AccusedNames == null) {
                            this.accusedCountType = 'single';
                            this.listOfAccused = [
                                {
                                    nameOfAccused: 'THE ACCUSED',
                                    pleaStatus: null
                                }
                            ]
                        } else {
                            this.accusedCountType = 'multiple';
                            this.listOfAccused = [];
                            this.currentConfiguration.AccusedNames.forEach((accusedName) => {
                                this.listOfAccused.push({ nameOfAccused: accusedName, pleaStatus: null });
                            });
                        }
                        if (this.currentConfiguration.PreviousChargeNumber != null) {
                            this.chargeNumber = this.currentConfiguration.PreviousChargeNumber + 1;
                        } else {
                            this.chargeNumber = 1;
                        }
                    }
                    this.configurationDirty = false;
                    this.sectionsInsertedEventData = null;
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {
            accusedCountTypeChanged: function () {
                if (this.accusedCountType == 'single') {
                    this.listOfAccused = [
                        {
                            nameOfAccused: 'THE ACCUSED',
                            pleaStatus: null
                        }
                    ];
                    this.currentConfiguration.AccusedNames = null;
                    this.configurationDirty = true;
                } else {
                    this.listOfAccused = [];
                    this.currentConfiguration.AccusedNames = [];
                    this.configurationDirty = true;
                }
            },
            addToList: function () {
                this.currentErrors = [];
                
                if (this.nameOfAccused == null) {
                    this.currentErrors.push('Please enter a name for the accused')
                }

                if (this.currentErrors.length == 0) {
                    this.listOfAccused.push({ nameOfAccused: this.nameOfAccused, pleaStatus: null });
                    this.currentConfiguration.AccusedNames.push(this.nameOfAccused);
                    this.configurationDirty = true;
                    this.nameOfAccused = null;
                }
            },
            deleteAccused: function (accused) {
                var indexToRemove = this.listOfAccused.indexOf(accused);
                if (indexToRemove >= 0) {
                    this.listOfAccused.splice(indexToRemove, 1);
                    this.currentConfiguration.AccusedNames.splice(indexToRemove, 1);
                    this.configurationDirty = true;
                }
            },
            insert: function () {
                this.currentErrors = []
                if ((this.chargeNumber == null) || (this.chargeNumber.length == 0)) {
                    this.currentErrors.push('A Charge Number is required');
                }
                if ((this.descriptionOfCharge == null) || (this.descriptionOfCharge.length == 0)) {
                    this.currentErrors.push('A Description of the Charge is required');
                }
                if (this.listOfAccused.length == 0) {
                    this.currentErrors.push('At least one Accused is required');
                } else {
                    this.listOfAccused.forEach((accused) => {
                        if (accused.pleaStatus == null) {
                            this.currentErrors.push('Guilty/Not Guilty selection is required for each accused')
                        }
                    });
                }

                if (this.currentErrors.length == 0) {
                    var metaData = {
                        SectionId: newUuid(),
                        Type: 'chargeandplea',
                        ChargeNumber: parseInt(this.chargeNumber),
                        Description: this.descriptionOfCharge,
                        Accused: []
                    }
                    this.currentConfiguration.PreviousChargeNumber = parseInt(this.chargeNumber);
                    this.configurationDirty = true;

                    var content = 'CHARGE: #' + this.chargeNumber + '<br>';
                    content += this.descriptionOfCharge.trim().replace(/(?:\r\n|\r|\n)/g, '<br>')
                    this.listOfAccused.forEach((accused) => {
                        var accusedPlea = (accused.pleaStatus == 'guilty') ? 'GUILTY' : 'NOT GUILTY';
                        if (this.accusedCountType == 'single') {
                            metaData.Accused.push({ Guilty: (accused.pleaStatus == 'guilty') });
                            accusedPlea = 'THE ACCUSED PLEADS ' + accusedPlea;
                        } else {
                            metaData.Accused.push({ Name: accused.nameOfAccused, Guilty: (accused.pleaStatus == 'guilty') });
                            accusedPlea = accused.nameOfAccused.toUpperCase() + ' PLEADS ' + accusedPlea;
                        }
                        content += '<br/>' + accusedPlea;
                    });
                    var base64EncodedMetaData = btoa(JSON.stringify(metaData));
                    this.$emit('beforeSectionsInsertOrUpdate');
                    Vue.nextTick(() => {
                        var chargeAndPleaSection =
                            $('<div data-type="chargeandplea"/>')
                                .attr('id', metaData.SectionId)
                                .attr('data-metadata', base64EncodedMetaData)
                                .html(content)
                                .attr('data-content', content)
                                .data('content', content)
                                .insertAfter(this.currentEditorSection)[0];
                        if (this.mode == 'edit') {
                            $(this.currentEditorSection).remove(); //remove the old section
                        }
                        this.sectionsInsertedEventData = { sections: [chargeAndPleaSection] };
                        if (this.configurationDirty) {
                            this.saveAndExit();
                        } else {
                            this.dialogOpen = false;
                        }
                    });
                }
            },
            saveAndExit: function () {
                this.$emit('configurationChanged', { dialogName: "chargeandplea", configuration: this.currentConfiguration });
                this.dialogOpen = false;
            },
            onDialogHidden: function () {
                this.accusedCountType = 'single';
                this.chargeNumber = 1;
                this.descriptionOfCharge = null;
                this.listOfAccused = [
                    {
                        nameOfAccused: 'THE ACCUSED',
                        pleaStatus: null
                    }
                ], 
                this.nameOfAccused = null;
                this.$emit('change', false);
                if (this.sectionsInsertedEventData) {
                    this.$emit('sectionsInserted', this.sectionsInsertedEventData);
                } else {
                    this.$emit('cancelled');
                }
                this.sectionsInsertedEventData = null;
            }
        }
    }
</script>
